import type { SessionUser } from "../../../../shared/auth/access";
import { asProcurementRole } from "../../domain/models";
import {
  defaultProcurementFilterId,
  procurementFiltersForRole,
  type ProcurementFilter,
} from "../../domain/selectors";
import { procurementStageOf } from "../../model";

export function requestStageFilterOptions(
  role: SessionUser["role"],
): ProcurementFilter[] {
  if (role === "PLANLAMA") {
    return [
      {
        id: "active",
        label: "Aktif talepler",
        matches: (request) =>
          !["Reddedildi", "Tamamlandı"].includes(procurementStageOf(request)),
      },
      {
        id: "completed",
        label: "Tamamlananlar",
        matches: (request) => procurementStageOf(request) === "Tamamlandı",
      },
    ];
  }

  return procurementFiltersForRole(asProcurementRole(role));
}

export function defaultRequestStageFilterId(role: SessionUser["role"]) {
  if (role === "PLANLAMA") return "active";
  return defaultProcurementFilterId(asProcurementRole(role));
}
